module.exports = __webpack_public_path__ + "img/chuva.68da88b9.png";